import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import Participacion from "./Participacion";
import FormParticipacion from "../formularios/FormParticipacion";
// Contexto
import { ModalContext } from "../../../context/modalContext";
import { AlertBoxContext } from "../../../context/alertBoxContext";
// jquery
import $ from "jquery";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";

const Participaciones = ({ idProvincia, idComunidad, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Datos de las participaciones de la comunidad
  const [datosParticipaciones, setDatosParticipaciones] = useState([]);
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  useEffect(() => {
    handleGetDatosParticipaciones();
  }, []);

  // Obtiene los datos de las participaciones de una comunidad
  const getDatosParticipaciones = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/comunidades/${idComunidad}/participaciones?count=9999`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Añade una participacion de una comunidad
  const postDatosParticipacion = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/comunidades/${idComunidad}/participaciones`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Manejador para obtener los datos de las participaciones de la comunidad
  const handleGetDatosParticipaciones = () => {
    //setLoading(true);
    getDatosParticipaciones()
      .then((response) => {
        setLoading(false);
        setDatosParticipaciones(response.items);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos de las participaciones de la comunidad
  const handlePostDatosParticipacion = (data) => {
    modalSetShow(false);
    //setLoading(true);
    // Hacemos el put para los datos de las participaciones
    postDatosParticipacion(data)
      .then((response) => {
        setDatosParticipaciones([...datosParticipaciones, response]);
        addAlert("Exito", "Se ha añadido correctamente la participación en actividad apostólica", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "No se ha podido añadir la situacion particular", "danger");
      });
  };

  // Elimina una participacion del estado con el id de la participacion
  const deleteParticipacionState = (idParticipacion) => {
    let participacion = datosParticipaciones.find((participacion) => participacion.id === idParticipacion);
    let misParticipaciones = [...datosParticipaciones];
    misParticipaciones.splice(misParticipaciones.indexOf(participacion), 1);
    setDatosParticipaciones(misParticipaciones);
  };

  return (
    <div style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Participación en distintas actividades apostólicas
            </Accordion.Toggle>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Añadir participación en actividad apostólica");
                modalSetContent(<FormParticipacion submissionHandler={handlePostDatosParticipacion} />);
              }}
            >
              Añadir
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0" className="p-3">
            <>
              {datosParticipaciones.length ? (
                datosParticipaciones.map((participacion) => {
                  return <Participacion key={participacion.id} idProvincia={idProvincia} idComunidad={idComunidad} participacion={participacion} deleteParticipacionState={deleteParticipacionState} />;
                })
              ) : (
                <p>No hay participaciones actualmente </p>
              )}
            </>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Participaciones;
